export default __webpack_public_path__ + "static/media/backup-image.4eec5d25.svg";